import clsx from "clsx";

interface SeparatorProps {
  direction?: "horizontal" | "vertical";
  className?: string;
  color?: string;
}

export const Separator = ({
  direction = "horizontal",
  className,
  color = "#F5F5F5",
}: SeparatorProps) => {
  const isVertical = direction === "vertical";

  return (
    <div
      className={clsx(
        "bg-current shrink-0",
        isVertical ? "w-px h-full" : "h-px max-w-full", // ocupa solo el espacio sobrante
        className
      )}
      style={{ backgroundColor: color }}
    />
  );
};
